import React, { FC } from 'react';
import theme from '@buoyhealth/common.buoy-theme';
import { Svg } from 'styled';
import { Color } from 'styled/theme/colors';

type Props = {
  className?: string;
  color?: Color;
  hasRoundedEnds?: boolean;
};

const PopUpCloseIcon: FC<Props> = ({
  className = '',
  color = theme.palette.gray[60],
  hasRoundedEnds,
}) => (
  <Svg width="22px" height="22px" viewBox="0 0 22 22" className={className}>
    <desc>Close Icon.</desc>
    <path
      d="M1.00077 1.00004L20.582 20.5813"
      stroke={color}
      strokeWidth="2"
      strokeLinecap={hasRoundedEnds ? 'round' : undefined}
      strokeLinejoin={hasRoundedEnds ? 'round' : undefined}
    />
    <path
      d="M20.582 1L1.00077 20.5813"
      stroke={color}
      strokeWidth="2"
      strokeLinecap={hasRoundedEnds ? 'round' : undefined}
      strokeLinejoin={hasRoundedEnds ? 'round' : undefined}
    />
  </Svg>
);

export default PopUpCloseIcon;
